/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import { useLocation } from "react-router";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

const HeadLanguage = ({ lang }) => {
  const location = useLocation();
  const navigate = useNavigate();
  var url = window.location.pathname.replace(".html", "");
  var language =  url.split("/")[1];
  if (
    language !== "fr" &&
    language !== "es" &&
    language !== "ru" &&
    language !== "ar" &&
    language !== "zh"
  ) {
    language = "en";
  }
  const [selected, setIsSelected] = useState(language)

  const splitUrl = (lang) => {
    let newURL;
    let temp = location.pathname.split("/")
    temp[1] = lang
    newURL = temp.join("/")
    return newURL + location.search;
  };

  function isSelected(languageSelected) {
    if (languageSelected === lang) {
      return "selected";
    } else return "";
  }

  return (
    <div className="align-self-center" style={{}}>
        <div className="d-flex">
          <select
            name="selectLang"
            onChange={(event) => {
              navigate(splitUrl(event.target.value));
              window.location.reload();
            }}
            className="select-lang"
            id="selectLang"
            defaultValue={selected}
          >
            <option value="en">
              ENGLISH
            </option>
            <option value="ar">
              العربية
            </option>
            <option value="zh">
              ﻿中文
            </option>
            <option value="ru">
              Русский
            </option>
            <option value="fr">
              FRANÇAIS
            </option>
            <option value="es">
              ESPAÑOL
            </option>
          </select>
         
        </div>
    </div>
  );
};

export default HeadLanguage;
